import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReportConfig } from '../models/report';

/**
 * Serviço para gerenciar as configurações de relatórios
 */
@Injectable({
  providedIn: 'root',
})
export class ReportConfigService {

  /**
   * Retorna todas as configurações de relatórios disponíveis
   */
  getReportConfigs(): Observable<ReportConfig[]> {
    return of(this.getReportConfigurations());
  }

  /**
   * Retorna um relatório específico por ID
   */
  getReportById(id: string): Observable<ReportConfig | undefined> {
    const report = this.getReportConfigurations().find(r => r.id === id);
    return of(report);
  }

  /**
   * Retorna todas as configurações de relatórios do sistema
   */
  private getReportConfigurations(): ReportConfig[] {
    return [
      {
        id: 'degree-days-etp',
        title: 'Graus Dias e ETP',
        description:
          'Relatório de Graus Dias e Evapotranspiração Potencial (ETP) acumulados e históricos para o período e estação especificados',
        icon: 'fa-thermometer-half',
        category: 'Balanço Hídrico',
        endpoint: '/bh/degree-days-etp',
        formats: ['PDF', 'XLS'],
        parameters: [
          {
            name: 'startDate',
            label: 'Data Inicial',
            type: 'date',
            required: true,
            placeholder: 'yyyy-MM-dd',
          },
          {
            name: 'endDate',
            label: 'Data Final',
            type: 'date',
            required: true,
            placeholder: 'yyyy-MM-dd',
          },
          {
            name: 'stationCode',
            label: 'Estação Meteorológica',
            type: 'select',
            required: true,
            options: [],
          },
        ],
      },
      // Relatório desabilitado temporariamente
      // {
      //   id: 'monthly-summary-rain-etp',
      //   title: 'Resumo Mensal de Chuva e ETP',
      //   description:
      //     'Relatório de resumo mensal de precipitação e evapotranspiração potencial acumulada',
      //   icon: 'fa-cloud-rain',
      //   category: 'Balanço Hídrico',
      //   endpoint: '/bh/monthly-summary-rain-etp',
      //   formats: ['PDF', 'XLS'],
      //   parameters: [
      //     {
      //       name: 'month',
      //       label: 'Mês',
      //       type: 'select',
      //       required: true,
      //       options: [],
      //     },
      //     {
      //       name: 'year',
      //       label: 'Ano',
      //       type: 'number',
      //       required: true,
      //       placeholder: '2025',
      //       min: 2000,
      //       max: 2100,
      //     },
      //   ],
      // },
    ];
  }
}
